var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popper',{attrs:{"trigger":_vm.trigger,"options":_vm.options}},[_c('div',{staticClass:"popper"},[_vm._t("content")],2),_vm._v(" "),_c('button',{attrs:{"slot":"reference"},slot:"reference"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }